import endpoints from '../../helpers/endpoints';

export const getDeviceHistory = async ({ identity }) => {
  const params = new URLSearchParams({ identity, page: '1', pageSize: '100' });
  const response = await fetch(`${endpoints.getDeviceHistory}?${params}`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Falha ao carregar histórico do dispositivo');
  }

  return response.json();
};
